<template>
  <div class="lifecycle-timeline">
    <div v-if="loading" class="text-center p-4">
      <div class="spinner-border text-primary" role="status"></div>
    </div>
    <div v-else-if="!events.length" class="text-muted text-center p-4">
      No lifecycle events recorded yet.
    </div>
    <div v-else class="timeline-list">
      <div
        v-for="(ev, idx) in events"
        :key="ev.id || idx"
        class="timeline-item"
        :class="'cat-' + (ev.event_category || 'other')"
      >
        <div class="timeline-dot"></div>
        <div class="timeline-body">
          <div class="timeline-head">
            <strong>{{ ev.title }}</strong>
            <span class="badge bg-light text-dark">{{ formatCategory(ev.event_category) }}</span>
          </div>
          <p v-if="ev.summary" class="timeline-summary">{{ ev.summary }}</p>
          <small class="text-muted">{{ formatDate(ev.event_date) }}</small>
          <small v-if="ev.actor_name" class="text-muted d-block">By {{ ev.actor_name }}</small>
        </div>
      </div>
    </div>
    <div v-if="currentStage" class="lifecycle-stage mt-3">
      <span class="badge bg-primary">Current stage: {{ formatStage(currentStage) }}</span>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { authUrl, execute } from "@/api";

export default {
  name: "EmployeeLifecycleTimeline",
  props: {
    employeeId: { type: [Number, String], default: 0 },
    applicationId: { type: [Number, String], default: 0 }
  },
  data() {
    return {
      loading: false,
      events: [],
      currentStage: ""
    };
  },
  watch: {
    employeeId: { immediate: true, handler() { this.load(); } },
    applicationId() { this.load(); }
  },
  methods: {
    load() {
      const eid = parseInt(this.employeeId, 10) || 0;
      const aid = parseInt(this.applicationId, 10) || 0;
      if (!eid && !aid) return;
      this.loading = true;
      const data = new FormData();
      data.append("function", "getEmployeeLifecycleTimeline");
      if (eid) data.append("employeeId", eid);
      if (aid) data.append("applicationId", aid);
      execute(data, authUrl)
        .then((res) => {
          this.loading = false;
          if (res.data.success && res.data.data) {
            this.events = res.data.data.events || [];
            this.currentStage = res.data.data.currentStage || "";
          }
        })
        .catch(() => {
          this.loading = false;
          this.events = [];
        });
    },
    formatDate(v) {
      if (!v) return "";
      const d = new Date(v);
      return isNaN(d.getTime()) ? v : d.toLocaleString();
    },
    formatCategory(c) {
      const m = {
        recruitment: "Recruitment",
        onboarding: "Onboarding",
        hire: "Hire",
        promotion: "Promotion",
        transfer: "Transfer",
        attrition: "Attrition",
        status: "Status"
      };
      return m[c] || c || "Event";
    },
    formatStage(s) {
      const m = {
        recruitment: "In recruitment",
        onboarding: "Onboarding",
        pre_hire: "Pre-hire",
        employed: "Active employee",
        active_career: "Active (career movement)",
        attrition: "Separated",
        unknown: "Unknown"
      };
      return m[s] || s;
    }
  }
};
</script>

<style scoped>
.timeline-list {
  position: relative;
  padding-left: 20px;
  border-left: 2px solid #e2e8f0;
}
.timeline-item {
  position: relative;
  padding-bottom: 20px;
  padding-left: 16px;
}
.timeline-dot {
  position: absolute;
  left: -27px;
  top: 4px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #3f51b5;
  border: 2px solid #fff;
  box-shadow: 0 0 0 2px #e2e8f0;
}
.cat-hire .timeline-dot { background: #16a34a; }
.cat-attrition .timeline-dot { background: #dc2626; }
.cat-promotion .timeline-dot { background: #7c3aed; }
.cat-transfer .timeline-dot { background: #0891b2; }
.cat-onboarding .timeline-dot { background: #d97706; }
.timeline-head {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}
.timeline-summary {
  margin: 4px 0;
  color: #475569;
  font-size: 14px;
}
</style>
